export const financeApiPath = process.env.REACT_APP_FINANCE_API_PATH;
export const finnhubApiPath = process.env.REACT_APP_FINNHUB_API_PATH;